import React from 'react';
import { Calendar, MapPin, Send } from 'lucide-react';

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('ne-NP', { year: 'numeric', month: 'short', day: 'numeric' });
};

const AssignedEventCard = ({ event, language, onSubmitReport }) => {
  const isUpcoming = event.status === 'upcoming' || event.status === 'current';
  const dateStr = event.date ? formatDate(event.date) : '—';

  return (
    <div className="group rounded-3xl border border-char-100 bg-white p-5 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-card-hover sm:p-6">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span
              className={`inline-block rounded-full px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wider ${
                isUpcoming
                  ? 'bg-primary-100 text-primary'
                  : 'bg-char-100 text-char-500'
              }`}
            >
              {isUpcoming
                ? language === 'ne' ? 'आगामी' : 'Upcoming'
                : language === 'ne' ? 'सम्पन्न' : 'Completed'}
            </span>
          </div>
          <h3 className="text-base font-extrabold text-char-900 line-clamp-2">{event.title}</h3>
        </div>
      </div>

      <div className="mt-3 space-y-2">
        <div className="flex items-center gap-2 text-sm text-char-500">
          <Calendar size={14} />
          <span>{dateStr}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-char-500">
          <MapPin size={14} />
          <span className="line-clamp-1">{event.location}</span>
        </div>
      </div>

      {event.description && (
        <p className="mt-3 line-clamp-2 text-sm text-char-400">{event.description}</p>
      )}

      <button
        onClick={() => onSubmitReport?.(event)}
        className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-primary-100 py-2.5 text-sm font-extrabold text-primary transition-all duration-200 hover:bg-primary hover:text-white"
      >
        <Send size={15} />
        {language === 'ne' ? 'रिपोर्ट बुझाउनुहोस्' : 'Submit Report'}
      </button>
    </div>
  );
};

export default AssignedEventCard;
